import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useResource } from '@tg/core/hooks';
import { Button } from '@tg/core/components';
import { Modal } from 'semantic-ui-react';

const CodatInvoice = ({ type, id, employerId }) => {
  const [successFailModal, setSuccessFailModal] = useState(null);
  const [open, setOpen] = useState(false);
  const { postResource } = useResource({
    url: `employers/${employerId}/${type}/${id}/codat`,
  });

  /* eslint-disable */
  const onCodatSubmit = () => {
    postResource({
      onSuccess: res => {
        setSuccessFailModal(res.json.message), setOpen(true);
      },
      onError: res => {
        setSuccessFailModal(res.json.message), setOpen(true);
      },
    });
  };

  return (
    <>
      <Button
        style={{ fontSize: '10px', whiteSpace: 'nowrap' }}
        size='small'
        color='tertiary'
        onClick={() => onCodatSubmit()}
      >
        Send to QBO
      </Button>
      <Modal
        open={open}
        header='Success'
        content={successFailModal}
        actions={['OK']}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

CodatInvoice.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['invoices']).isRequired,
  employerId: PropTypes.string.isRequired,
};

export default CodatInvoice;
